import React, { useState, useRef, useEffect } from 'react';
import { string, node } from 'prop-types';

/**
 * BackgroundImage component.
 */
const BackgroundImage = ({
  image,
  children
}) => {
  const ref = useRef();
  const [backgroundImage, setBackgroundImage] = useState(null);
  useEffect(() => {
    if (image) {
      const imageUrl = new URL(image);
      imageUrl.searchParams.set('quality', '90');
      imageUrl.searchParams.set('webp', 'true');
      return setBackgroundImage(`url(${imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.href})`);
    }
    return () => {};
  }, [image]);
  if (!image) {
    return children;
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain'
    },
    ref: ref,
    className: "background-image"
  }, children);
};
BackgroundImage.defaultProps = {
  image: null
};
BackgroundImage.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The image path */
  image: string,
  /** The children to render above the background image. */
  children: node.isRequired
} : {};
export default BackgroundImage;